module.exports = __webpack_public_path__ + "static/media/Elo.62c146f6.png";